import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const WebsiteLayout = () => {
  return (
    <>
      <header className="full_width">
        <Header />
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="full_width">
        <Footer />
      </footer>
    </>
  );
};

export default WebsiteLayout;
